import React, { useEffect, useRef, useState } from 'react';
import { View, Text, StyleSheet, Linking, Clipboard, Platform } from 'react-native';
import { useDispatch, useSelector } from 'react-redux';
import Toast from 'react-native-easy-toast';
import { useNavigation } from '@react-navigation/native';
import { WEB_URL, REMOTE_CONFIG_KEYS } from '../../config/Constants';
import Config from '../../libraries/ReactNativeConfig';
import Share from '../../libraries/ReactNativeShare';
import { getScreenWidth } from '../../utils/LayoutUtility';
import colors from '../../theme/Colors';
import FastImageView from '../FastImageView';
import { getMinifiedImage } from '../../utils/ImageUtility';
import FoxyShadowButton from '../../lib/FoxyShadowButton';
import images from '../../theme/Images';
import { isBlank, isPresent, isWeb } from '../../utils/BooleanUtility';
import DermatProfileEditCard from '../pro/DermatProfileEditCard';
import DynamicLinkManager from '../../utils/DynamicLinkManager';
import { SCREEN_CONSTANTS } from '../../config/ScreenConstants';
import { AnalyticsManager, EventParameterKey, EventType } from '../../analytics';
import { jsonParser } from '../../utils/JsonUtility';
import RemoteConfig from '../../utils/RemoteConfig';
import DebouncedTouchableWithoutFeedback from '../shared/DebouncedTouchableWithoutFeedback';
import withNavigation from '../../utils/WithNavigation';
import NavigationService from '../../navigator/NavigationService';
import { setPhoneNumberModalInfo } from '../../actions/LoginActions';
import Utility from '../../utils/Utility';
import { getStoreRef } from '../../store/StoreUtility';
import TYPEFORM_CUSTOM_INJECTED_JAVASCRIPT from '../../injected/TypeForm';

const TaskPromptCard = (props) => {
  const navigation = useNavigation();
  const dispatch = useDispatch();
  const [loader, setLoader] = useState(false);
  const toastRef = useRef(null);
  const handle = useSelector((state) => state.UserAccountInfo.profile.handle) || '';
  const shareTemplate = jsonParser(RemoteConfig.getValue(REMOTE_CONFIG_KEYS.share_handle)) || {};
  const name = useSelector((state) => state.UserAccountInfo.profile.name) || '';
  const guestToken = useSelector((state) => state.UserAccountInfo?.guestProfile.guestAuthToken);
  const isUserProfileCreated = useSelector((state) => state.UserAccountInfo.isInfluencerProfileCreated);
  const authToken = getStoreRef().getState()?.UserAccountInfo?.authToken;
  const { itemData: { arguments: { type = '' } = {} } = {} } = props;
  if(isUserProfileCreated) return null;
  useEffect(() => {
    const { previousScreen = '', cardType = '' } = props;
    AnalyticsManager.logEvent(EventType.INFLUENCER.DERMAT_PROFILE, {
      [EventParameterKey.TYPE]: type || cardType,
      [EventParameterKey.SCREEN_NAME]: previousScreen,
    });
  }, []);

  const onTapInvite = () => {
    const { messageTemplate: { greetingText = '', closingText = '' } = {} } = shareTemplate;
    AnalyticsManager.logEvent(EventType.INFLUENCER.INFLUENCER_SHARE, {
      handle,
      screenName: SCREEN_CONSTANTS.INFLUENCER,
    });
    const title = Config.APP_NAME;
    const url = `${isWeb() ? Config.WEB_URL : Config.URI_HOST}/@${handle}`;
    const message = `${greetingText} ${name}. ${closingText}`;
    setLoader(false);
    if (isWeb()) {
      if (navigator.share) {
        navigator
          .share({
            title,
            text: message,
            url,
          })
          .then(() => toastRef.current.show('Shared Successfully! 🎉', 2000))
          .catch((err) => console.error(err));
      } else {
        Clipboard.setString(`${Config.URI_HOST}/@${handle}`);
      }
    }
    shareLink(title, message, url);
  };

  const shareLink = (title, message, url) => {
    Share.open({
      title,
      message: `${message} ${url}`,
    });
  };

  const {
    itemData: {
      title = '',
      body = '',
      imageUrl = '',
      cta_text = '',
      ctaText = '',
      destination = '',
      arguments: {
        cardSize = '',
        card_size = '',
        ctaIconUrl = '',
        titleColor = colors.black,
        shareMessage = '',
        shareTitle = '',
      } = {},
      external_link = '',
      image_url = '',
      background_color = colors.light_blue,
      backgroundColor = colors.light_blue,
      externalLink = '',
    } = {},
    showActionIcon = false,
    buttonAction,
    isInfluencerProfileCreated = false,
    previousScreen = '',
    isCenterAligned = false,
    featureStyle = {},
  } = props;
  
  const image = isPresent(image_url) ? image_url : imageUrl;
  const cardDisplay = isPresent(card_size) ? card_size : cardSize;

  const cardColor = isPresent(backgroundColor) ? backgroundColor : background_color;
  const buttonText = isPresent(ctaText) ? ctaText : cta_text;
  const externalLinks = isPresent(external_link) ? external_link : externalLink;
  if (isInfluencerProfileCreated) {
    <DermatProfileEditCard />;
  }

  const handleScreenNavigation = ({ route, slug, extra }) => {
    setLoader(false);
    navigation.navigate(route, { slug, extra });
  };

  const onTapSurveyCards = () => {
    setLoader(false);
    if (isBlank(destination)) return null;
    if (destination.includes('typeform.com/')) {
      const deepLink = `${destination}?user_id=${guestToken}`;
      navigation.navigate('TypeFormWebUrlView', {
        destination: deepLink,
        title: 'Skin Assessment',
        customInjectedJavascript: TYPEFORM_CUSTOM_INJECTED_JAVASCRIPT,
        showPlaceholder: true,
      });
    }
  };

  const onTapShareCta = () => {
    setLoader(false);
    Share.open({
      title: shareTitle,
      message: shareMessage,
    });
  };

  const startCallBackJourney = () => {
    DynamicLinkManager.handleLinkWithoutInternalTrackingParams(destination, handleScreenNavigation);
  };

  const onPressButton = () => {
    AnalyticsManager.logEvent(EventType.discoveryEvents.ITEM_CLICK, {
      [EventParameterKey.TYPE]: EventType.INFLUENCER.DERMAT_PROFILE,
      [EventParameterKey.CTA]: cta_text,
      [EventParameterKey.SCREEN_NAME]: previousScreen,
    });
    const handleButtonAction = () => {
      setLoader(true);
      if (typeof buttonActions[type] === 'function') {
        buttonActions[type]();
      } else if (typeof buttonAction === 'function') {
        setLoader(false);
        buttonAction();
      } else if (isPresent(destination)) {
        DynamicLinkManager.handleLinkWithoutInternalTrackingParams(destination, handleScreenNavigation);
      } else if (isPresent(externalLinks)) {
        Linking.openURL(externalLinks).catch((err) => console.error('Error opening external link', err));
      }
    };
    handleButtonAction();
  };

  const BottomButton = () => {
    const buttonWidth = isPresent(featureStyle?.width) ? featureStyle?.width : getScreenWidth() - 32;
    return (
      <FoxyShadowButton
        width={buttonWidth}
        underlayWidth={buttonWidth - 24}
        title={buttonText}
        onPress={onPressButton}
        style={styles.buttonContainer}
        textStyle={styles.buttonText}
        firstColor={colors.black}
        secondColor={colors.black}
        underlayColor={colors.black}
        actionIcon={{ uri: ctaIconUrl || images.link_icon }}
        showActionIcon={isPresent(ctaIconUrl) || showActionIcon}
        Loading={loader}
      />
    );
  };

  const subContainerStyle = cardDisplay === 'large' ? styles.subColumnContainer : styles.subRowContainer;
  const imageStyle = cardDisplay === 'large' ? styles.largeImage : styles.imageContainer;
  const { width: scaledWidth = getScreenWidth() - 24, fontSize = 18 } = featureStyle;

  const containerStyle = [
    isCenterAligned || isBlank(featureStyle) || previousScreen === SCREEN_CONSTANTS.INFLUENCER
      ? styles.centerAlignContainer
      : styles.container,
    { width: scaledWidth, backgroundColor: cardColor },
  ];
  const bodyContainer = [styles.textContainer, { width: scaledWidth - 100 }];

  const invokeLoginFlow = () => {
    dispatch(setPhoneNumberModalInfo(Utility.getLoginModalInfo('PRE_ROUTINE')));
    setLoader(false);
    NavigationService.renderOnboarding({
      furtherAction: startCallBackJourney,
      navigationRef: navigation,
    });
  };

  const invokeHandleSelectionFlow = () => {
    setLoader(false);
    navigation.navigate('HandleSelection');
  };

  const buttonActions = {
    invite: onTapInvite,
    update_survey: onTapSurveyCards,
    request_callback: isBlank(authToken) ? invokeLoginFlow : startCallBackJourney,
    share: onTapShareCta,
    signUp: invokeHandleSelectionFlow,
  };

  return (
    <DebouncedTouchableWithoutFeedback style={containerStyle} onPress={onPressButton}>
      <View style={subContainerStyle}>
      <Toast style={styles.toast} ref={toastRef} />
        <FastImageView resizeMode='contain' source={getMinifiedImage(image, imageStyle.width)} style={imageStyle} />
        <View style={bodyContainer}>
          <Text ellipsizeMode='tail' numberOfLines={1} style={[styles.title, { fontSize, color: titleColor }]}>
            {title}
          </Text>
          <Text ellipsizeMode='tail' numberOfLines={3} style={[styles.subtitle, { color: titleColor }]}>
            {body}
          </Text>
        </View>
      </View>
     
      <BottomButton />
    </DebouncedTouchableWithoutFeedback>
  );
};

export default withNavigation(TaskPromptCard);

const styles = StyleSheet.create({
  container: {
    padding: 16,
    width: getScreenWidth() - 24,
    backgroundColor: colors.light_blue,
    borderRadius: 12,
    alignContent: 'center',
    marginTop: 12,
  },
  centerAlignContainer: {
    padding: 16,
    width: getScreenWidth() - 24,
    backgroundColor: colors.light_blue,
    borderRadius: 12,
    alignContent: 'center',
    alignSelf: 'center',
    marginTop: 12,
  },
  subRowContainer: {
    flexDirection: 'row',
    alignContent: 'center',
    alignSelf: 'center',
    paddingHorizontal: 12,
  },
  subColumnContainer: {
    alignContent: 'center',
    alignSelf: 'center',
    paddingHorizontal: 12,
  },
  imageContainer: {
    height: 60,
    width: 60,
    paddingBottom: 12,
    alignSelf: 'center',
  },
  largeImage: {
    height: 120,
    width: 176,
    paddingBottom: 12,
    alignSelf: 'center',
  },
  textContainer: {
    paddingVertical: 8,
    paddingHorizontal: 6,
    width: getScreenWidth() - 42,
    ...Platform.select({
      web: { width: getScreenWidth() / 1.3 },
    }),
  },
  title: {
    color: colors.foxyBlack,
    fontSize: 18,
    fontFamily: 'Roboto-Bold',
    alignSelf: 'flex-start',
    ...Platform.select({
      web: { width: getScreenWidth() / 1.3 },
    }),
  },
  subtitle: {
    fontSize: 14,
    fontFamily: 'Roboto-Regular',
    alignSelf: 'flex-start',
    color: colors.foxyBlack,
  },
  buttonContainer: { marginTop: 12 },
  buttonText: { borderRadius: 8 },
  toast: {
    position: 'absolute',
    bottom: 20, // Or adjust as needed for consistent UI placement
    zIndex: 1000,
  },
});
